// Extracted Editor Logic (React Draft WYSIWYG)

import { useState, useCallback } from "react";
import { Editor } from "react-draft-wysiwyg";
import {
  EditorState,
  ContentState,
  convertFromHTML,
  convertToRaw,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import { debounce } from "lodash";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

// ===============================
// EDITOR HOOK
// ===============================
export const useRichTextEditor = () => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const clearEditor = () => setEditorState(EditorState.createEmpty());

  const loadHtmlToEditor = (html) => {
    const blocksFromHTML = convertFromHTML(html);
    const contentState = ContentState.createFromBlockArray(
      blocksFromHTML.contentBlocks,
      blocksFromHTML.entityMap
    );
    const newState = EditorState.createWithContent(contentState);
    setEditorState(newState);
  };

  const getHtmlFromEditor = () =>
    draftToHtml(convertToRaw(editorState.getCurrentContent()));

  const onEditorChange = useCallback(
    debounce((state) => setEditorState(state), 50),
    []
  );

  return {
    editorState,
    onEditorChange,
    clearEditor,
    loadHtmlToEditor,
    getHtmlFromEditor,
  };
};

// ===============================
// EDITOR COMPONENT
// ===============================
export const RichTextEditor = ({ editorState, onEditorChange, onBlur }) => {
  return (
    <Editor
      editorState={editorState}
      onEditorStateChange={onEditorChange}
      onBlur={onBlur}
      toolbar={{
        options: [
          "inline",
          "blockType",
          "fontSize",
          "list",
          "textAlign",
          "colorPicker",
          "link",
          "embedded",
          "emoji",
          "image",
          "remove",
          "history",
        ],
      }}
      wrapperStyle={{ border: "1px solid #ccc", borderRadius: "4px" }}
      editorStyle={{ padding: 12, minHeight: 150 }}
    />
  );
};
